import { IManageMembershipState } from "./manageMembership.types";

export const initialManageMembershipState: IManageMembershipState = {
	membershipDetails: [],
	loading: false,
	error: null,
};
